import WithRender from "../../templates/containers/saveCustomizationPopUp.html";
import axios from "../../axios-auth";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";
import * as R from "ramda";
import { event } from "jquery";

export default WithRender({
  data() {
    return {
      name: "",
      description: ""
    };
  },
  computed: {
    ...mapGetters([
      "getShowCustomizationPopup",
      "getUrl",
      "getSweetAlert",
      "getCustomer",
      "getProjectCustomer",
      "getSelectionId",
      "getLocalStorageDataObject",
      "getProductId"
    ]),
    getDisableClass: function () {
      return this.name === "" ? "disabled" : "";
    }
  },
  methods: {
    ...mapActions(["setShowCustomizationPopup"]),

    closeCustomizationPopup: function (event) {
      event && event.preventDefault();
      this.setShowCustomizationPopup(false);
      jQuery("body").removeClass("printq_product_customization_popup_open");
    },

    createCustomization: function () {
      if (this.name) {
        axios.instance
          .post(
            this.getUrl(axios.createCustomizationUrl),
            new URLSearchParams({
              name: this.name,
              description: this.description,
              selection: JSON.stringify(this.getLocalStorageDataObject),
              clientId: this.getCustomer,
              productId: this.getProductId,
              overwrite: 0
            })
          )
          .then(response => {
            if (
              response.data.status_code &&
              response.data.status_code == "name_already_exists"
            ) {
              this.getSweetAlert({
                text: i18n.t(
                  "A customization with this name already exists. Would you like to overwrite it?"
                ),
                icon: "warning",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: i18n.t("Overwrite"),
                cancelButtonText: i18n.t("Cancel")
              }).then(overwrite => {
                if (overwrite.isConfirmed) {
                  axios.instance
                    .post(
                      this.getUrl(axios.createCustomizationUrl),
                      new URLSearchParams({
                        name: this.name,
                        description: this.description,
                        selection: JSON.stringify(
                          this.getLocalStorageDataObject
                        ),
                        clientId: this.getCustomer,
                        productId: this.getProductId,
                        overwrite: 1
                      })
                    )
                    .then(response => {
                      this.getSweetAlert({
                        text: i18n.t(
                          "You have successfully saved your customization."
                        ),
                        icon: "success",
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: i18n.t("Ok")
                      });
                    });
                }
              });
            } else if (
              response.data.status_code &&
              response.data.status_code == "too_many_customizations"
            ) {
              const saveItemsUrlLabel = i18n.t("your saved items");
              this.getSweetAlert({
                html: i18n.t(
                  "You have already saved the maximum number of items. Please go to {savedItemsUrl} and delete one.",
                  {
                    savedItemsUrl:
                      "<a href='" +
                      this.getUrl(axios.myCustomizationsUrl) +
                      "'>" +
                      saveItemsUrlLabel +
                      "</a>"
                  }
                ),
                icon: "warning",
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: i18n.t("Ok")
              });
            } else {
              this.getSweetAlert({
                text: i18n.t("You have successfully saved your customization."),
                icon: "success",
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: i18n.t("Ok")
              });
            }
          })
          .catch(error => {
            console.log("Error " + error);
            this.getSweetAlert({
              text: i18n.t("Failed to save customization. Try again later."),
              icon: "error",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: i18n.t("Ok")
            });
          })
          .finally(() => {
            this.closeCustomizationPopup();
          });
      }
    }
  }
});
